import type { Options } from 'redux-first-router';
import queryString from 'query-string';

export const getRouterOptions = (options: Options): Options => {
  return {
    querySerializer: queryString,
    ...options,
  };
};
